// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__aaEBI","title":"AfterFrontImage_title__GS8tf"};